module.exports = __webpack_public_path__ + "img/sound_on.c58330cd.png";